import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import './adBanner.scss';
import {isMobile} from 'react-device-detect';
import {useSelector} from 'react-redux';
import Config from '../../../Config';

const AdBannerMain = (props) => {
  const organizationData = useSelector((state) => state.welcomeBlock.organizationState);
  let desktopImg = props.iContent?.adBannerGeneralDesktopImage?.value?.url;
  let mobileImg = props.iContent?.adBannerGeneralMobileImage?.value?.url;
  let defaultUrlBanner = props.iContent?.adBannerGeneralUrl?.value;

  if (organizationData != null && organizationData?.organizationCodeList?.value?.length > 0) {
    if (
      organizationData?.organizationAdBannerDesktopImage?.value?.url != null &&
      organizationData?.organizationAdBannerMobileImage?.value?.url != null &&
      organizationData?.organizationAdBannerUrl != null
    ) {
      desktopImg = organizationData?.organizationAdBannerDesktopImage?.value?.url;
      mobileImg = organizationData?.organizationAdBannerMobileImage?.value?.url;
      defaultUrlBanner = organizationData?.organizationAdBannerUrl;
    }
  }
  if (desktopImg != null && mobileImg != null) {
    const moveToUrl = () => {
      props.context.navigateTo(defaultUrlBanner);
    };

    const getImgLink = () => {
      return isMobile ? Config.epiBaseUrl + mobileImg : Config.epiBaseUrl + desktopImg;
    };

    let imgLink = getImgLink();

    if (imgLink != null) {
      return (
        <div className={`main-container-ad-banner ${defaultUrlBanner ? 'link' : ''}`}>
          {defaultUrlBanner != null ? <Image onClick={moveToUrl} src={imgLink} /> : <Image src={imgLink} />}
        </div>
      );
    } else {
      return <div></div>;
    }
  } else return <div></div>;
};

export default AdBannerMain;
